import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Tab strip shared by AdminDashboard (Periods) and CompanyOverview (MOR
// Dashboard) — these used to be two separate sidebar links; consolidated
// into tabs of one "MOR Dashboard" sidebar entry instead. Periods is
// admin/super_admin only (RequireAdmin), so finance_reviewer — who can only
// reach the dashboard — never sees a tab strip with just one working option.
export default function AdminTabs() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return null;

  return (
    <div style={s.tabRow}>
      <NavLink to="/admin/company" style={({ isActive }) => ({ ...s.tab, ...(isActive ? s.tabActive : {}) })}>
        MOR Dashboard
      </NavLink>
      <NavLink to="/admin" end style={({ isActive }) => ({ ...s.tab, ...(isActive ? s.tabActive : {}) })}>
        Periods
      </NavLink>
    </div>
  );
}

const s = {
  tabRow: { display: 'flex', borderBottom: '1px solid #E5E7EB', marginBottom: '20px' },
  tab: {
    padding: '8px 2px', marginRight: '22px', fontSize: '13px', fontWeight: 600,
    color: '#9CA3AF', textDecoration: 'none', borderBottom: '2px solid transparent', marginBottom: '-1px',
  },
  tabActive: { color: '#1B2A4A', borderBottomColor: '#1B2A4A' },
};
